import { ChangeDetectionStrategy, Component, computed, input, InputSignal, model, ModelSignal, Signal } from '@angular/core';
import { MatChipOption, MatChipSelectionChange } from '@angular/material/chips';
import { FilterChipModel, FilterChipsComponent } from '@libs/common/components';
import { ScrollIndicatorDirective } from '@libs/shared/ui';

@Component({
  selector: 'ui-form-chip-filter-group',
  templateUrl: './chip-filter-group.component.html',
  styleUrls: ['./chip-filter-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [
    ScrollIndicatorDirective,
  ],
  imports: [
    FilterChipsComponent,
    MatChipOption,
  ],
})
export class ChipFilterGroupComponent {
  public filterChips: InputSignal<FilterChipModel[]> = input.required();
  public totalCount: InputSignal<number> = input.required();
  public allLabel: InputSignal<string> = input('Alle');
  public selected: ModelSignal<FilterChipModel[]> = model<FilterChipModel[]>([]);

  // ui-filter-chips compares the chips by reference, so the selected chips are taken from filterChips()
  public selectedChips: Signal<FilterChipModel[]> = computed(() =>
    this.filterChips().filter((chip: FilterChipModel) => this.selected().some((selectedChip: FilterChipModel) => selectedChip.id === chip.id)),
  );

  public hasSelected: Signal<boolean> = computed(() => this.selectedChips().length > 0);

  public selectAll(event: MatChipSelectionChange): void {
    if (event.selected && this.hasSelected()) {
      this.selected.set([]);
    }
  }
}
